      let checkJquery = setInterval(function() {
        if (window.$) {
$(window).on('load',function(){
   $('.swipercolllist').css('visibility','visible');
   
});

$(window).on('load',function(){
   $('.swiperlogolist').css('visibility','visible');
});

$(document).ready(function(){
  $('.dynmaicslideshow').css('opacity','1');
});

          clearInterval(checkJquery);
        }
      }, 100);

//  $(window).scroll(function() {
//   if (window.matchMedia('(max-width: 990px)').matches) {
//     var sticky = $('.site-header'),
//       scroll = $(window).scrollTop();
  
//     if (scroll>33){
//       $('.site-main').addClass("stuck-header");
//       sticky.addClass("stuck"); 
//       }
//       else if(scroll<250){  
//         $('.site-main').removeClass("stuck-header");
//         sticky.removeClass("stuck");
//       }
      
    
// }
// });


